export default "__VITE_ASSET__CTl16TcA__"